export const TRIGGER_OUTDATED_THREAD_ALERT = 'TRIGGER_OUTDATED_THREAD_ALERT';
export const TRIGGER_BULK_UPDATE_FAILURE_ALERT = 'TRIGGER_BULK_UPDATE_FAILURE_ALERT';
export const THREADS_UPDATED_BULK_NOTIFICATION = 'THREADS_UPDATED_BULK_NOTIFICATION';